<template>
  <GridsTwelveGrid
    class="justify-items-center"
    v-if="productVariations?.products?.data && productVariations?.products?.data.length > 0"
  >
    <h2 class="col-span-6 col-start-1 mb-8 justify-self-start laptop:col-span-8 laptop:col-start-2">
      {{ $t("other-variations") }}
    </h2>
    <ProductCard
      v-for="(variation, index) in productVariations?.products?.data"
      :brand="props.brand?.attributes?.slug"
      :product="variation"
      :key="JSON.stringify(variation)"
      :class="{
        'col-start-1 col-end-4 mb-4 laptop:col-start-3 laptop:col-end-5 laptop:mb-0 laptop:w-[100%]': index === 0,
        'col-start-4 col-end-7 justify-self-start laptop:col-start-6 laptop:col-end-8 ': index === 1,
        'col-start-2 col-end-6 mx-auto max-w-[73%] justify-self-end  laptop:col-start-9 laptop:col-end-11 laptop:mx-0 laptop:max-w-full ':
          index === 2,
      }"
    />
  </GridsTwelveGrid>
</template>
<script setup lang="ts">
import { ProductBrandInfoFragment, GetProductVariationsQuery, GetProductBySlugQuery, ProductFragment } from "#gql";
const props = defineProps<{
  brand: ProductBrandInfoFragment | null | undefined;
  product: ProductFragment | null | undefined;
}>();

watch(
  () => props.product,
  (product) => {
    if (product) {
      getProductVariations();
    }
  },
  { immediate: true }
);

const productVariations = ref<GetProductVariationsQuery | null>(null);

async function getProductVariations() {
  const { data: total } = await useAsyncGql({
    operation: "GetCountOfProductVariations",
    variables: {
      product_type_option: props.product?.attributes?.product_type_option?.data?.attributes?.slug,
      brand: props.brand?.attributes?.slug,
      slug: props.product?.attributes?.slug,
    },
    options: {
      lazy: false,
    },
  });

  if (total.value?.products?.meta?.pagination?.total && total.value?.products?.meta?.pagination?.total > 0) {
    const start = Math.max(
      0,
      Math.floor(Math.random() * Math.floor(total.value?.products?.meta?.pagination?.total - 3))
    );

    const { data: productVarieties } = await useAsyncGql({
      operation: "GetProductVariations",
      variables: {
        product_type_option: props.product?.attributes?.product_type_option?.data?.attributes?.slug,
        brand: props.brand?.attributes?.slug,
        slug: props.product?.attributes?.slug,
        start: start,
      },
      options: {
        lazy: false,
      },
    });

    productVariations.value = productVarieties.value;
  }
}

const { t: $t } = useI18n();
</script>
<style lang="scss" scoped></style>
